import clsx from 'clsx';
import styles from './styles.module.scss';

interface ShopFnbFacilityHeaderProps {
    title: string;
    description: string;
    isHorizontal: boolean;
    tabIndex: number;
    className?: string;
    isFABPage?: boolean;
}

const ShopFnbFacilityHeader = ({ title, description, tabIndex, isHorizontal, className, isFABPage }: ShopFnbFacilityHeaderProps) => {
    const headerClassname = clsx(styles.header, isHorizontal ? styles['header--horizontal'] : styles['header--vertical'], className);
    const titleClassname = clsx(styles.title, isHorizontal ? styles['title--horizontal'] : styles['title--vertical'], isFABPage ? 'font-number' : '');
    const descriptionClassname = clsx(styles.description, isHorizontal ? styles['description--horizontal'] : styles['description--vertical']);

    return (
        <div data-region-nav tabIndex={tabIndex} data-interactive aria-label={`${title}, ${description}`} className={headerClassname}>
            <h1 className={titleClassname}>{title}</h1>
            <p className={descriptionClassname}>{description}</p>
        </div>
    );
};

export default ShopFnbFacilityHeader;
